import React, { useContext } from 'react'
import './profile.css'
import Navigation from '../../components/navigation/Navigation'
import Footer from '../../components/footer/Footer'
import { AuthContext } from '../../contexts/AuthContext'

function Profile() {
    const { userData } = useContext(AuthContext);
    
  return (
    <div className="profile">
        <Navigation
            background='theme-color'
            logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
        />

        <div className='user_details'>
            <div className='profile_image'>
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1644243032/account_2_oszrwo.png" alt="" />
            </div>

            <div className='profile_data'>
                <h5>{userData.data && userData.data.name}</h5>
                <h5>{userData.data && userData.data.email}</h5>
                <h5>{userData.data && userData.data.phone}</h5>
            </div>
        </div>

        <Footer />
    </div>
  )
}

export default Profile